import { alerts } from 'keys';
import { useCallback } from 'react';
import { useAlert } from 'components/Alerts/hooks';
import { ReactComponent as AddIcon } from 'assets/icons/Add.svg';
import { SvgIcon } from '@mui/material';

const useHeaderBtns = () => {
    const { setAlerts } = useAlert()

    const openAddTestTakerPopup = useCallback(() => {
        setAlerts(alerts.createTestTaker, true)
    }, [])

    const headerBtns = [
        // {
        //     id: 2,
        //     icon: <SvgIcon component={AddIcon} inheritViewBox />,
        //     label: "הוספת תלמיד",
        //     action: openAddTestTakerPopup,
        //     height: "35px",
        // }
    ]

    return headerBtns
}

export default useHeaderBtns